import { ICalendarAuth } from '../entities/calendar_auth';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';

export class CalendarAuth extends BaseOrganizationEndpoints {
  /**
   * Checks the calendar authorization of the current user, or of `asUserId` when given.
   * Checking another user requires being able to make reservations for them.
   */
  async getAvailablePermissions(
    provider: 'microsoft',
    asUserId?: string
  ): Promise<ResponseWithStatus<ICalendarAuth>> {
    const url = asUserId
      ? this.addGenericParamsToUrl(`/v1/calendars/authorization/${provider}`, {
          as_user_id: asUserId
        })
      : `/v1/calendars/authorization/${provider}`;
    return this.requestWithStatus<ICalendarAuth>('GET', url);
  }

  async getMicrosoftPermissions(asUserId?: string) {
    return this.getAvailablePermissions('microsoft', asUserId);
  }
}
